<template>
  <section class="sonar-lab-iframe__container">
    <div class="sonar-lab-iframe__wrapper">
      <div
        class="sonar-lab-iframe__area"
        @click="handleIframeFocus"
        v-if="iframeArea"
      ></div>
      <iframe
        class="sonar-lab-iframe__iframe"
        id="sonar-iframe"
        width="100%"
        height="100%"
        :src="ptaURL"
        title="Lab Session"
        frameborder="0"
        allow="clipboard-read; clipboard-write"
        allowfullscreen
      ></iframe>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'SonarLabIframe',
  data() {
    return {
      iframeArea: true,
    }
  },
  computed: {
    ...mapState({
      currentLab: state => state.labs.currentLab,
      currentLabSession: state => state.labs.currentLabSession,
    }),
    ptaURL() {
      return this.currentLabSession?.pta_url
    },
  },
  methods: {
    handleIframeFocus() {
      if (!this.iframeArea) return
      const sonarIframe = document.getElementById('sonar-iframe')
      sonarIframe.focus()
      const labLoading = !sonarIframe.contentWindow.frames.length
      if (labLoading) return (this.iframeArea = false)
      const innerIframeExist = sonarIframe.contentWindow[0]?.frames.length
      if (innerIframeExist) sonarIframe.contentWindow[0].focus()
      this.iframeArea = false
    },
  },
  mounted() {
    const iframe = document.getElementById('sonar-iframe')
    iframe?.addEventListener('blur', () => (this.iframeArea = true))
  },
  beforeDestroy() {
    const iframe = document.getElementById('sonar-iframe')
    iframe?.removeEventListener('blur', () => null)
  },
}
</script>

<style lang="scss" scoped>
.sonar-lab-iframe {
  width: 100%;
  height: 100%;
  min-height: 280px;
  border-top: 1px solid var(--tundora-gray);

  &__wrapper {
    height: 100%;
    position: relative;
    display: flex;
    overflow: hidden;
    width: 100%;
    padding-top: 56.25%;
  }
  &__container {
    width: 100%;
    background: var(--dark-brighter);
  }
  &__area {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    border-radius: 10px;
    max-height: calc(100vh - 125px);
    z-index: 200;
    background-color: transparent;
  }
  &__iframe {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    border-radius: 10px;
    max-height: calc(100vh - 125px);
  }
}
</style>
